import { BaseError } from './BaseError';
export class AuthError extends BaseError {}
